import http from "../http-common";

class EmailDataService {

  sendEmail(data) {
    return http.post("/email/activate", data);
  }


}

export default new EmailDataService();